import { cn } from "@/lib/utils";
import { CardProps } from "./card";

function Skeleton({
  variant = "default",
  className,
  ...props
}: React.ComponentProps<"div"> & { variant?: CardProps["variant"] }) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "animate-pulse rounded-md bg-muted",
        {
          "bg-muted": variant === "default" || variant === "muted",
          "bg-purple-100": variant === "purple",
        },
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
